import { Component, Inject, NgZone, OnDestroy, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Observable, Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { COUNTRY_CODES } from "../../data/country-codes";
import { AddJoiningInterestTimingsComponent } from "src/app/pages/new-v2-pages/new-v2-component/add-joining-interest-timings/add-joining-interest-timings.component";
import { debounceTime, filter, skip, switchMap } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'sm-member-edit-opted-timings',
  templateUrl: './member-edit-opted-timings.component.html',
  styleUrls: ['./member-edit-opted-timings.component.scss']
})
export class MemberEditOptedTimingsComponent implements OnInit, OnDestroy {
  pay_in_advance: any = 0;

  isEntityIndividual: any = sessionStorage.getItem("isEntityIndividual");
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  serviceList: any = [];
  memberimg: any = {
    img: null,
    thumb: null,
  };
  home_status: any = sessionStorage.getItem("home_service_status");
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  requestStatus: any = "1";
  public memberData: any = {
    price: 0,
    discount: 0,
    coupon_discount: 0,
  };
  selectedServiceType: any;
  repeatArray: any = new Array(0);
  form: UntypedFormGroup;
  tempObj: any;
  selectedDays: any = [];
  taxSlabData: any = [];
  productsList: any = [];
  employeeList: any = [];
  selectedEmployee: any;

  editmode: boolean = false;
  k: any = "../";
  apisub: Subscription;
  loader: boolean = false;
  memberDetailsData: any = [];
  uploadedImage: any = {};
  constructor(
    @Inject(MAT_DIALOG_DATA) private parentdata: any,
    private _ngZone: NgZone,
    private _snackBar: MatSnackBar,
    private _modelRef: MatDialog,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<MemberEditOptedTimingsComponent>,
    private loaderservice: LoaderServiceService,
    private http: HttpClient,
    private fb: UntypedFormBuilder
  ) {
    this.form = this.fb.group({
      items: this.fb.array([]),
    });

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLLED_MEMBER_DETAILS
      ) {
        this.memberDetailsData = [];
        if (resdata.result) {
          this.memberDetailsData = resdata.result[0];
          if (
            this.memberDetailsData.services &&
            typeof this.memberDetailsData.services == "string"
          ) {
            this.memberDetailsData.services = JSON.parse(
              this.memberDetailsData.services
            );
          }
          if (
            this.memberDetailsData.timings &&
            typeof this.memberDetailsData.timings == "string"
          ) {
            this.memberDetailsData.timings = JSON.parse(
              this.memberDetailsData.timings
            );
          }
          if (
            this.memberDetailsData.custom_items &&
            typeof this.memberDetailsData.custom_items == "string"
          ) {
            this.memberDetailsData.custom_items = JSON.parse(
              this.memberDetailsData.custom_items
            );
          }
          if (
            this.memberDetailsData.assign_to &&
            typeof this.memberDetailsData.assign_to == "string"
          ) {
            this.memberDetailsData.assign_to = JSON.parse(
              this.memberDetailsData.assign_to
            );
          }
          if (
            this.memberDetailsData.products &&
            typeof this.memberDetailsData.products == "string"
          ) {
            this.memberDetailsData.products = JSON.parse(
              this.memberDetailsData.products
            );
          }
          if (this.memberDetailsData.coupon_info) {
            this.memberDetailsData.coupon_info =
              typeof this.memberDetailsData.coupon_info == "string"
                ? JSON.parse(this.memberDetailsData.coupon_info)
                : this.memberDetailsData.coupon_info;
          }
          if (this.memberDetailsData.service_mode == 0) {
            this.memberDetailsData.s_mode = "Home service";
          } else if (this.memberDetailsData.service_mode == 1) {
            this.memberDetailsData.s_mode = "In-premise service";
          } else if (this.memberDetailsData.service_mode == 2) {
            this.memberDetailsData.s_mode = "Virtual service";
          }

          this.memberDetailsData.opted_services = this.memberDetailsData
            .services
            ? this.getServiceNames(this.memberDetailsData.services)
            : null;
          this.memberDetailsData.opted_cis = this.memberDetailsData.custom_items
            ? this.getCustomItemNames(this.memberDetailsData.custom_items)
            : null;
          this.memberDetailsData.opted_products = this.memberDetailsData
            .products
            ? this.getProductsNames(this.memberDetailsData.products)
            : null;
          if (
            this.memberDetailsData.timings &&
            this.memberDetailsData.timings != "null"
          ) {
            this.memberDetailsData.opted_timings = this.formatSchedule(
              this.memberDetailsData.timings
            );
          }
          this.memberData.discount = this.memberDetailsData.discount;
          this.memberData.address = this.memberDetailsData?.address;

          this.selectedServiceType = this.memberDetailsData.service_mode;
          console.log(this.memberDetailsData);
        }
        // this.loaderservice.showLoader = false
        // this.loader = false
        this.apiservice.getEmployeeList(this.parentdata.entityHash);
        // this.calculateCouponDiscount()
        this.onEdit();
      }
      if (
        resdata.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resdata);

        this.serviceList = [];
        if (resdata.result) {
          if (this.selectedServiceType == "1") {
            resdata.result.forEach((element: any) => {
              if (element.shopStatus == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resdata.result.forEach((element: any) => {
              if (element.homeStatus == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resdata.result.forEach((element: any) => {
              if (element.for_virtual == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }

        this.memberimg.img = this.memberDetailsData.image_url;
        this.memberimg.thumb = this.memberDetailsData.image_thumb_url;

        this.memberData.name = this.memberDetailsData.name;
        this.memberData.address = this.memberDetailsData?.address;

        this.selectedCountryCode = this.countryList.find(
          (country) => country.dial_code === this.memberDetailsData.country_code
        );
        this.memberData.phone = this.memberDetailsData.phone;
        this.memberData.note = this.memberDetailsData.notes;
        this.memberData.dob = this.memberDetailsData.dob;
        this.memberData.gender = this.memberDetailsData.gender;
        this.memberData.billing_period = this.memberDetailsData.billing_period;
        this.pay_in_advance =
          this.memberDetailsData.pay_in_advance

        this.memberData.email = this.memberDetailsData.email;
        this.memberData.start_date =
          this.memberDetailsData.membership_start_date;
        this.memberData.coupon_code = this.memberDetailsData.coupon_code;
        if (this.memberDetailsData.timings) {
          this.selectedDays = this.memberDetailsData.timings.map(
            (item: any) => {
              return {
                startTime: item.start_time.slice(0, 5),
                endTime: item.end_time.slice(0, 5),
                day: {
                  dayName: this.getDayName(item.weekday - 1),
                  day: item.weekday,
                  timeSlots: [],
                  is_selected: 1,
                },
              };
            }
          );
        }
        this.selectedJobs = [];
        if (this.memberDetailsData.services) {
          this.memberDetailsData.services.forEach((element: any) => {
            this.selectServicesForEdit(element);
            // if(element.current_status == 3){
            // }
          });
        }
        this.form = this.fb.group({
          items: this.fb.array([]),
        });
        if (this.memberDetailsData.custom_items) {
          this.memberDetailsData.custom_items.forEach((element: any) => {
            if (element) {
              this.items.push(this.createFieldWithItem(element));
            }
            // if(element.current_status == 3){
            // }
          });
        }

        this.loader = false;
        this.loaderservice.showLoader = false;
        this.editmode = true;
      }
      if (resdata.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        this.uploadedImage = {};
        console.log(resdata.result.url);
        this._ngZone.run(() => {
          setTimeout(() => {
            this.uploadedImage.imgUrl = resdata.result?.url;
            this.uploadedImage.thumbnail = resdata.result?.thumbnail;

            this.memberimg.img = resdata.result?.url;
            this.memberimg.thumb = resdata.result?.thumbnail;

            // this.memberData.profileThumbImg = resdata.result?.url
            // this.memberData.profileThumbImgReal = resdata.result?.thumbnail

            // this.memberData.profileImg = resdata.result?.url
            this.loaderservice.showLoader = false;
          }, 3000);
        });
        // this.newSalaryData.imgUrl = res.result?.url;fff
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_EDIT_MEMBER_TIMINGS_DATA
      ) {
        if (resdata.result) {
          this.activemodal.close(resdata.result);
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resdata.result) {
          this.taxSlabData = resdata.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resdata.result) {
          this.taxSlabData = resdata.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resdata);

        this.productsList = [];
        if (resdata.result) {
          if (this.selectedServiceType == "1") {
            resdata.result.forEach((element: any) => {
              if (element.shop_status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resdata.result.forEach((element: any) => {
              if (element.home_status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resdata.result.forEach((element: any) => {
              if (element.virtual_status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }
        if (this.memberDetailsData.products) {
          this.memberDetailsData.products.forEach((element: any) => {
            this.selectProducts(element);
            // if(element.completed_by && element.completed_by != 'null'){
            //   let total_completed = 0
            //   element.completed_by.forEach((item:any) => {
            //     total_completed += item.competed_services_qty
            //   });

            //   element.total_completed_services_qty = total_completed
            // }
            // if(element.current_status == 3){
            // }
          });
        }
      }

      if (resdata.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT) {
        this.employeeList = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            if (element.isExEmployee != 1) {
              this.employeeList.push(element);
            }
          });

          const index = this.employeeList.findIndex(
            (employee: any) =>
              employee.employeeHashId ==
              this.memberDetailsData.assign_to?.hash_id
          );

          if (index != -1) {
            this.selectedEmployee = this.employeeList[index];
          }
        }
      }
    });
  }

  ngOnInit(): void {
    this.home_status = sessionStorage.getItem("home_service_status");
    this.shop_status = sessionStorage.getItem("shop_service_status");
    this.virtual_status = sessionStorage.getItem("virtual_service_status");
    // work of assignment of services

    if (this.shop_status != 2) {
      this.selectedServiceType = "1";
    } else if (this.home_status != 2) {
      this.selectedServiceType = "0";
    } else if (this.virtual_status != 2) {
      this.selectedServiceType = "2";
    }

    console.log(this.parentdata);
    this.loader = true;

    this.apiservice.getEnrolledMemberDetails(this.parentdata.memberHash);
  }
  onCancel() {
    this.editmode = false;
  }
  onEdit() {
    this.selectedProducts = [];
    this.selectedJobs = [];
    this.items.clear();
    // this.loader = true
    this.selectedServiceType = this.memberDetailsData.service_mode;
    this.loaderservice.showLoader = true;
    this.memberData.price = this.memberDetailsData.membership_fee;
    if (this.isEntityForeign == "0") {
      this.apiservice.getEntityTaxSlabData(this.parentdata.entityHash);
    } else if (this.isEntityForeign == "1") {
      this.apiservice.getInternationalEntityTaxSlabsData(
        this.parentdata.entityHash
      );
    }

    this.apiservice.getServicesTypesList(this.parentdata.entityHash, "0", "0");
    this.apiservice.getEntityProductList(this.parentdata.entityHash, "1");
  }

  createFieldWithItem(item: any): UntypedFormGroup {
    const itemGroup = this.fb.group({
      name: [
        {
          item_name: item.item_name,
          item_desc: item.item_description,
          hash_id: item.inventory_item_hash,
          image_thumb_url: null,
        },
        Validators.required,
      ],
      price: [item.item_price, Validators.required],
      count: [item.item_qty, Validators.required],
      tax_slab: [item.tax_slab_hash ? item.tax_slab_hash : "default"],
    });

    const filterControl = itemGroup.get("name") as UntypedFormControl;

    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300),
    //   filter((value) => typeof value === "string" && value.length > 2),
    //   switchMap((value) => this.fetchOptions(value))
    // );
    // this.filteredOptions.push(filteredOption);

    const priceControl = itemGroup.get("price") as UntypedFormControl;
    let previousPrice = item.item_price; // ✅ Set to initial price
    // Add initial price to total once

    // this.memberData.price += item.item_price;

    // ✅ Skip initial trigger to prevent early reset
    priceControl.valueChanges.subscribe((value) => {
      console.log("price changed");

      const parsedValue = Number(value);
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        this.memberData.price =
          this.memberData.price - previousPrice + parsedValue;
        previousPrice = parsedValue;
      }
      // ✅ Recalculate total from all sources
      // this.memberData.price = 0;

      // this.selectedJobs.forEach((element: any) => {
      //   const val = Number(element.price);
      //   if (!isNaN(val)) this.memberData.price += val;
      // });

      // this.selectedProducts.forEach((element: any) => {
      //   const val = Number(element.price);
      //   if (!isNaN(val)) this.memberData.price += val;
      // });

      // const items = this.form.get("items")?.value || [];
      // items.forEach((element: any) => {
      //   const val = Number(element.price);
      //   if (!isNaN(val)) this.memberData.price += val;
      // });

      this.calculateCouponDiscount();
    });

    // ✅ Optionally add the item price to memberData.price initially (if needed)
    // this.memberData.price += item.item_price;

    return itemGroup;
  }

  getOneHourSlot(date: Date) {
    // Convert to local time string in 24-hour format
    const localTimeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Get hours and minutes
    let [hours, minutes] = localTimeString.split(":").map(Number);

    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;

    // Calculate next hour
    let endHour = (startHour + 1) % 24;

    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour: any) => hour.toString().padStart(2, "0");

    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`,
    };
  }
  getDayName(dayNumber: any) {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // Ensure the input is a valid day number (0-6)
    if (dayNumber >= 0 && dayNumber <= 6) {
      return daysOfWeek[dayNumber];
    } else {
      return "Invalid day number";
    }
  }
  getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  getProductsNames(products: any) {
    console.log(products);

    return products.map((product: any) => product.product_name).join(", ");
  }

  getCustomItemNames(cis: any) {
    console.log(cis);

    return cis.map((ci: any) => ci.item_name).join(", ");
  }

  formatSchedule(schedule: any[]) {
    return schedule.map((item) => {
      const weekday = this.getWeekdayString(item.weekday);
      const startTime = this.formatTime(item.start_time);
      const endTime = this.formatTime(item.end_time);
      return `${weekday}: ${startTime} - ${endTime}`;
    });
  }
  formatTime(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );
  searchString: UntypedFormControl = new UntypedFormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  removeSelectedDay(index: any) {
    console.log(index);

    this.selectedDays.splice(index, 1);
  }

  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }

  openTimings() {
    // this.loader.showLoader = true
    let dialogref = this._modelRef.open(AddJoiningInterestTimingsComponent, {
      width: "450px",
      data: {
        title: "Select day and time",
        serviceType: this.selectedServiceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);
        res.forEach((element: any) => {
          this.selectedDays.push(element);
        });
      }
    });
  }
  selectedJobs: any = [];
  selectServices(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    this.serviceList[index].selectedCount = 1;
    this.serviceList[index].price =
      this.selectedServiceType == "0"
        ? item.discountStatus == 1
          ? item.homeDiscountedPrice
          : item.home_rate
        : this.selectedServiceType == "1"
        ? item.discountStatus == 1
          ? item.shopDiscountedPrice
          : item.shop_rate
        : item.discountStatus == 1
        ? item.virtual_discounted_amount
        : item.virtual_rate;

    this.selectedJobs.push(this.serviceList[index]);
    if (this.selectedServiceType == "0") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price += this.serviceList[index].homeDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price += this.serviceList[index].shopDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price +=
          this.serviceList[index].virtual_discounted_amount;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].virtual_rate;
      }
    }
    this.serviceList[index].toShow = false;
    this.calculateCouponDiscount();
  }

  changeServiceType(type: string) {
    this.selectedJobs = [];
    this.memberData.price = 0;
    this.selectedServiceType = type;
    this.loaderservice.showLoader = true;
    this.apiservice.getServicesTypesList(this.parentdata.entityHash, "0", "0");
    this.apiservice.getEntityProductList(this.parentdata.entityHash, "1");
  }

  decreaseServiceCount(item: any, index: any) {
    if (this.selectedJobs[index].selectedCount == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);
      if (!item.service_type_hash && !item.hash_id) {
        this.memberData.price -= item.price;
        this.selectedJobs.splice(index, 1);
      } else {
        if (this.selectedServiceType == "0") {
          if (this.selectedJobs[index].discountStatus == 1) {
            this.memberData.price -=
              this.selectedJobs[index].homeDiscountedPrice;
          } else if (this.selectedJobs[index].discountStatus == 0) {
            this.memberData.price -= this.selectedJobs[index].home_rate;
          }
        } else if (this.selectedServiceType == "1") {
          if (this.selectedJobs[index].discountStatus == 1) {
            this.memberData.price -=
              this.selectedJobs[index].shopDiscountedPrice;
          } else if (this.selectedJobs[index].discountStatus == 0) {
            this.memberData.price -= this.selectedJobs[index].shop_rate;
          }
        } else if (this.selectedServiceType == "2") {
          if (this.selectedJobs[index].discountStatus == 1) {
            this.memberData.price -=
              this.selectedJobs[index].virtual_discounted_amount;
          } else if (this.selectedJobs[index].discountStatus == 0) {
            this.memberData.price -= this.selectedJobs[index].virtual_rate;
          }
        }

        this.serviceList[index1].toShow = true;
        this.selectedJobs.splice(index, 1);
      }
    } else {
      if (!item.service_type_hash && !item.hash_id) {
        this.memberData.price -= item.price / item.selectedCount;
      } else {
        if (this.selectedServiceType == "0") {
          if (this.selectedJobs[index].discountStatus == 1) {
            this.memberData.price -=
              this.selectedJobs[index].homeDiscountedPrice;
          } else if (this.selectedJobs[index].discountStatus == 0) {
            this.memberData.price -= this.selectedJobs[index].home_rate;
          }
        } else if (this.selectedServiceType == "1") {
          if (this.selectedJobs[index].discountStatus == 1) {
            this.memberData.price -=
              this.selectedJobs[index].shopDiscountedPrice;
          } else if (this.selectedJobs[index].discountStatus == 0) {
            this.memberData.price -= this.selectedJobs[index].shop_rate;
          }
        } else if (this.selectedServiceType == "2") {
          if (this.selectedJobs[index].discountStatus == 1) {
            this.memberData.price -=
              this.selectedJobs[index].virtual_discounted_amount;
          } else if (this.selectedJobs[index].discountStatus == 0) {
            this.memberData.price -= this.selectedJobs[index].virtual_rate;
          }
        }
      }
      item.price -= item.price / item.selectedCount;
      this.selectedJobs[index].selectedCount--;
    }
    this.calculateCouponDiscount();
  }
  increaseServiceCount(item: any, index: any) {
    console.log(item);

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (!item.service_type_hash && !item.hash_id) {
      this.memberData.price += item.price / item.selectedCount;
    } else {
      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price += this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price += this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price += this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price += this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price +=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price += this.selectedJobs[index].virtual_rate;
        }
      }
    }
    item.price += item.price / item.selectedCount;
    this.selectedJobs[index].selectedCount++;
    this.calculateCouponDiscount();
  }

  removeSelectedJobs(item: any, i: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    console.log();

    this.memberData.price -= item.price;

    if (index != -1) {
      this.serviceList[index].toShow = true;
    }
    this.selectedJobs.splice(i, 1);
    this.calculateCouponDiscount();
  }

  // Get the form array of items
  get items(): UntypedFormArray {
    return this.form.get("items") as UntypedFormArray;
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): UntypedFormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as UntypedFormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as UntypedFormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.memberData.price = this.memberData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }
      this.calculateCouponDiscount();
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  formChecker(): boolean {
    const phone = this.memberData?.phone?.trim(); // safely get phone, remove spaces

    // Check if phone is missing or empty
    if (!phone) {
      return true;
    }

    // Check length between 3 and 17
    return phone.length < 3 || phone.length > 17;
  }

  namechecker() {
    if (this.memberData.name && this.memberData.name.trim() !== "") {
      return false; // valid
    } else {
      return true; // invalid
    }
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentdata.entityHash}&searchKey=${value}&pageNo=1&count=25`
    );
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.memberData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
    this.calculateCouponDiscount();
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.memberData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  assetType: number = 0;
  public fileName: string = "";
  public assetList: any[] = [];
  onUploadImage(event: any) {
    this.assetType = 0;
    console.log(event);
    console.log(event.target);

    console.log(event.target.files);
    if (event.target.value === "") {
      // this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(" ")) {
      this.fileName = this.fileName.replace(/\s+/g, "_");
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf(".") + 1);
    const mimeType = event.target.files[0].type;
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    // this.loader = true;
    let formData: FormData = new FormData();
    formData.append("recfile", event.target.files[0]);

    if (mimeType.startsWith("image/")) {
      console.log("image");
      if (sizeinKb > 5120) {
        // this.loader = false;
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok"
        );
        return;
      }
      this.assetType = 1;
      this.loaderservice.showLoader = true;
      this.apiservice.uploadAssets(formData, 2);
      return;
    }
    if (mimeType.startsWith("video/")) {
      console.log("Video");
      if (sizeinKb > 15360) {
        // this.loader = false;
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok"
        );
        return;
      }
      this.assetType = 2;
      this.loaderservice.showLoader = true;
      this.apiservice.uploadAssets(formData, 3);
      return;
    }
    // this.loader = false;
    this._snackBar.open("File format not supported", "Ok");
  }

  selectServicesForEdit(item: any) {
    console.log("item:::>>>>>", item);
    if (item.service_type_hash) {
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      if (index != -1) {
        // this.serviceList[index].current_status = 3
        item.selectedCount = item.service_qty;
        this.serviceList[index].selectedCount = item.service_qty;
        this.serviceList[index].price = item.rate;
        // this.serviceList[index].price = (this.selectedServiceType == '0')
        // ? (this.serviceList[index].discountStatus == 1 ? this.serviceList[index].homeDiscountedPrice* this.serviceList[index].selectedCount : this.serviceList[index].home_rate* this.serviceList[index].selectedCount)
        // : (this.selectedServiceType == '1' ? (this.serviceList[index].discountStatus == 1 ? this.serviceList[index].shopDiscountedPrice* this.serviceList[index].selectedCount : this.serviceList[index].shop_rate* this.serviceList[index].selectedCount)
        // : (this.serviceList[index].discountStatus == 1 ? this.serviceList[index].virtual_discounted_amount* this.serviceList[index].selectedCount : this.serviceList[index].virtual_rate* this.serviceList[index].selectedCount) )

        this.selectedJobs.push(this.serviceList[index]);

        // if(this.selectedServiceType == '0'){
        //   if(this.serviceList[index].discountStatus == 1){
        //     this.memberData.price += this.serviceList[index].homeDiscountedPrice * item.selectedCount
        //   }
        //   else if(this.serviceList[index].discountStatus == 0){
        //     this.memberData.price += this.serviceList[index].home_rate * item.selectedCount
        //   }
        // }
        // else if(this.selectedServiceType == '1'){
        //   if(this.serviceList[index].discountStatus == 1){
        //     this.memberData.price += this.serviceList[index].shopDiscountedPrice * item.selectedCount
        //   }
        //   else if(this.serviceList[index].discountStatus == 0){
        //     this.memberData.price += this.serviceList[index].shop_rate * item.selectedCount
        //   }
        // }
        // else if(this.selectedServiceType == '2'){
        //   if(this.serviceList[index].discountStatus == 1){
        //     this.memberData.price += this.serviceList[index].virtual_discounted_amount * item.selectedCount
        //   }
        //   else if(this.serviceList[index].discountStatus == 0){
        //     this.memberData.price += this.serviceList[index].virtual_rate * item.selectedCount
        //   }
        // }
        this.serviceList[index].toShow = false;
      } else {
        let data = {
          currency: item.currency,
          currency_symbol: item.currency_symbol,
          description: item.description,
          hash_id: null, //can be null
          service_type_hash: null,
          imgUrl: item.img_url,
          price: item.rate,
          serviceName: item.service_name,
          selectedCount: item.service_qty,
          approxTime: item.service_time,
          status: item.status,
          service_sac_code: null,
          tax_slab_hash: null,
        };

        this.selectedJobs.push(data);
      }
    } else {
      let data = {
        currency: item.currency,
        currency_symbol: item.currency_symbol,
        description: item.description,
        hash_id: null, //can be null
        service_type_hash: null,
        imgUrl: item.img_url,
        price: item.rate,
        serviceName: item.service_name,
        selectedCount: item.service_qty,
        approxTime: item.service_time,
        status: item.status,
        service_sac_code: null,
        tax_slab_hash: null,
      };

      this.selectedJobs.push(data);
    }
    console.log("item::job::::>>>", this.selectedJobs);

    this.calculateCouponDiscount();
  }

  serviceInfo: any = [];
  productInfo: any = [];
    onPost() {
    this.serviceInfo = [];


    // --------------- new data formation --------------------

    let obj = {
      hash_id: this.memberDetailsData.hash_id,
      entity_hash: this.parentdata.entityHash,
      // address: this.memberData.address ?? null,

      // name: this.memberData.name ? this.memberData.name : "New Customer",
      // country_code: this.selectedCountryCode.dial_code,
      // phone: this.memberData.phone ? this.memberData.phone : "0000000000",
      // gender: this.memberData.gender ? this.memberData.gender : null,
      // billing_period: this.memberData.billing_period
      //   ? this.memberData.billing_period
      //   : null,
      // service_mode: this.selectedServiceType,
      // dob: this.memberData.dob ? this.formatDate1(this.memberData.dob) : null,
      // start_date: this.memberData.start_date
      //   ? this.formatDate1(this.memberData.start_date)
      //   : null,
      // image_url: this.memberimg.img ?? null,
      // image_thumb_url: this.memberimg.thumb ?? null,
      // email: this.memberData.email,
      // services: this.serviceInfo,
      // products: this.productInfo,
      timings: this.selectedDays.map((item: any) => {
        return {
          weekday: item.day.day,
          start_time: item.startTime,
          end_time: item.endTime,
        };
      }),
      // custom_items: this.form.get("items")!.value.map((item: any) => {
      //   return {
      //     item_name: item.name.item_name ? item.name.item_name : item.name,
      //     item_desc: item.name.item_desc ?? "",
      //     item_inventory_hash: item.name.hash_id ?? "",
      //     item_img_url: item.name.image_thumb_url ?? "",
      //     item_qty: item.count,
      //     item_price: +item.price,
      //     tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
      //   };
      // }),
      // note: this.memberData.note,
      // default_assign_to_hash: this.selectedEmployee?.employeeHashId ?? null,
      // subscription_fee: this.memberData.price,
      // discount: this.memberData.discount,
      // net_payable:
      //   this.memberData.price -
      //   this.memberData.discount -
      //   this.memberData.coupon_discount,
      // pay_in_advance: this.pay_in_advance
    };

    Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null) {
        delete (obj as any)[key];
      }
    });
    // obj.services.forEach((element: any) => {
    //   Object.keys(element).forEach((key) => {
    //     if ((element as any)[key] === null) {
    //       delete (element as any)[key];
    //     }
    //   });
    // });
    // obj.products.forEach((element: any) => {
    //   Object.keys(element).forEach((key) => {
    //     if ((element as any)[key] === null) {
    //       delete (element as any)[key];
    //     }
    //   });
    // });
    // obj.custom_items.forEach((element: any) => {
    //   Object.keys(element).forEach((key) => {
    //     if ((element as any)[key] === null) {
    //       delete (element as any)[key];
    //     }
    //   });
    // });
    console.log(obj);

    this.loaderservice.showLoader = true;
    this.apiservice.editMemberTimingsData(obj);
  }


  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  selectedProducts: any = [];
  selectProducts(item: any) {
    console.log("product_item:::>>>", item);
    if (item.entity_product_hash) {
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash
      );
      if (index != -1) {
        this.productsList[index].selectedCount = item.item_qty;
        item.selectedCount = item.item_qty;

        // this.productsList[index].price = (this.selectedServiceType == '0')
        // ? (this.productsList[index].discountStatus == 1 ? this.productsList[index].home_discounted_price : this.productsList[index].home_price)
        // : (this.selectedServiceType == '1' ? (this.productsList[index].discountStatus == 1 ? this.productsList[index].shop_discounted_price : this.productsList[index].shop_price)
        // : (this.productsList[index].discountStatus == 1 ? this.productsList[index].virtual_discounted_price : this.productsList[index].virtual_price) )
        this.productsList[index].price = item.product_price;

        this.selectedProducts.push(this.productsList[index]);

        this.productsList[index].toShow = false;
      }
      // adding by selection fresh
    } else if (item.hash_id) {
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      if (index != -1) {
        this.productsList[index].selectedCount = 1;
        this.productsList[index].price =
          this.selectedServiceType == "0"
            ? item.discount_status == 1
              ? item.home_discounted_price
              : item.home_price
            : this.selectedServiceType == "1"
            ? item.discount_status == 1
              ? item.shop_discounted_price
              : item.shop_price
            : item.discount_status == 1
            ? item.virtual_discounted_price
            : item.virtual_price;
        this.selectedProducts.push(this.productsList[index]);
        if (this.selectedServiceType == "0") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].home_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].home_price;
          }
        } else if (this.selectedServiceType == "1") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].shop_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].shop_price;
          }
        } else if (this.selectedServiceType == "2") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].virtual_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].virtual_price;
          }
        }
        this.productsList[index].toShow = false;
      } else {
        let data = {
          currency: item.currency,
          currency_symbol: item.currency_symbol,
          entity_product_hash: null,
          hash_id: null, //can be null
          selectedCount: item.item_qty,
          product_desc: item.product_description,
          image_url: item.product_img_url,
          product_name: item.product_name,
          thumb_image_url: item.product_img_url,
          price: item.product_price,
          status: item.status,
          tax_slab_hash: null,
          product_hsn_code: null,
        };

        this.selectedProducts.push(data);
      }
    } else {
      let data = {
        currency: item.currency,
        currency_symbol: item.currency_symbol,
        entity_product_hash: null,
        hash_id: null, //can be null
        selectedCount: item.item_qty,
        product_desc: item.product_description,
        image_url: item.product_img_url,
        product_name: item.product_name,
        thumb_image_url: item.product_img_url,
        price: item.product_price,
        status: item.status,
        tax_slab_hash: null,
        product_hsn_code: null,
      };

      this.selectedProducts.push(data);
    }

    console.log("product_item:::>>>job", this.selectedProducts);

    this.calculateCouponDiscount();
  }

  decreaseProductCount(item: any, index: any) {
    console.log(item);

    if (this.selectedProducts[index].selectedCount == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);
      if (!item.entity_product_hash && !item.hash_id) {
        this.memberData.price -= item.price;
        this.selectedProducts.splice(index, 1);
      } else {
        if (this.selectedServiceType == "0") {
          if (this.selectedProducts[index].discount_status == 1) {
            this.memberData.price -=
              this.selectedProducts[index].home_discounted_price;
          } else if (this.selectedProducts[index].discount_status == 0) {
            this.memberData.price -= this.selectedProducts[index].home_price;
          }
        } else if (this.selectedServiceType == "1") {
          if (this.selectedProducts[index].discount_status == 1) {
            this.memberData.price -=
              this.selectedProducts[index].shop_discounted_price;
          } else if (this.selectedProducts[index].discount_status == 0) {
            this.memberData.price -= this.selectedProducts[index].shop_price;
          }
        } else if (this.selectedServiceType == "2") {
          if (this.selectedProducts[index].discount_status == 1) {
            this.memberData.price -=
              this.selectedProducts[index].virtual_discounted_price;
          } else if (this.selectedProducts[index].discount_status == 0) {
            this.memberData.price -= this.selectedProducts[index].virtual_price;
          }
        }

        this.productsList[index1].toShow = true;
        this.selectedProducts.splice(index, 1);
      }
    } else {
      if (!item.entity_product_hash && !item.hash_id) {
        this.memberData.price -= item.price / item.selectedCount;
      } else {
        if (this.selectedServiceType == "0") {
          if (this.selectedProducts[index].discount_status == 1) {
            this.memberData.price -=
              this.selectedProducts[index].home_discounted_price;
          } else if (this.selectedProducts[index].discount_status == 0) {
            this.memberData.price -= this.selectedProducts[index].home_price;
          }
        } else if (this.selectedServiceType == "1") {
          if (this.selectedProducts[index].discount_status == 1) {
            this.memberData.price -=
              this.selectedProducts[index].shop_discounted_price;
          } else if (this.selectedProducts[index].discount_status == 0) {
            this.memberData.price -= this.selectedProducts[index].shop_price;
          }
        } else if (this.selectedServiceType == "2") {
          if (this.selectedProducts[index].discount_status == 1) {
            this.memberData.price -=
              this.selectedProducts[index].virtual_discounted_price;
          } else if (this.selectedProducts[index].discount_status == 0) {
            this.memberData.price -= this.selectedProducts[index].virtual_price;
          }
        }
      }
      item.price -= item.price / item.selectedCount;
      this.selectedProducts[index].selectedCount--;
    }
    this.calculateCouponDiscount();
  }
  increaseProductCount(item: any, index: any) {
    console.log(item);

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);
    if (!item.entity_product_hash && !item.hash_id) {
      this.memberData.price += item.price / item.selectedCount;
    } else {
      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price +=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price += this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price +=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price += this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price +=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price += this.selectedProducts[index].virtual_price;
        }
      }
    }
    item.price += item.price / item.selectedCount;
    this.selectedProducts[index].selectedCount++;
    this.calculateCouponDiscount();
  }

  removeSelectedProducts(item: any, i: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    this.memberData.price -= item.price;

    if (index != -1) {
      this.productsList[index].toShow = true;
    }

    this.selectedProducts.splice(i, 1);
    this.calculateCouponDiscount();
  }

  emptyCheck: boolean = false;
  checkIfEmpty() {
    this.selectedJobs.forEach((element: any) => {
      if (element.price == null || element.price == "") {
        this.emptyCheck = true;
      } else {
        this.emptyCheck = false;
      }
    });
    console.log(this.emptyCheck);
  }

  changeServicePrice(item: any) {
    console.log(item.price);
    this.memberData.price = 0;
    this.selectedJobs.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.selectedProducts.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.memberData.price += +element.price;
    });

    this.checkIfEmpty();
    this.calculateCouponDiscount();
    // this.calculateDiscount()
  }

  changeProductPrice(item: any) {
    console.log(item.price);
    this.memberData.price = 0;
    this.selectedJobs.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.selectedProducts.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.memberData.price += +element.price;
    });

    this.checkIfEmptyForProduct();
    this.calculateCouponDiscount();
    // this.calculateDiscount()
  }

  emptyCheckForProduct: boolean = false;
  checkIfEmptyForProduct() {
    this.selectedProducts.forEach((element: any) => {
      if (element.price == null || element.price == "") {
        this.emptyCheckForProduct = true;
      } else {
        this.emptyCheckForProduct = false;
      }
    });
  }

  selectedDaysChecker() {
    if (this.isEntityIndividual == "1") {
      if (this.selectedDays.length == 0) {
        return true;
      } else {
        return false;
      }
    } else if (this.isEntityIndividual == "0") {
      return false;
    } else {
      return false;
    }
  }

  onMemberSelected(event: any) {
    this.selectedEmployee = event.value;
    console.log(this.selectedEmployee);
  }

  calculateCouponDiscount() {
    if (this.memberData.coupon_code) {
      if (
        this.memberDetailsData?.coupon_use_limit == 0 ||
        this.memberDetailsData?.coupon_use_limit >
          this.memberDetailsData?.coupon_use_counter
      ) {
        this.memberData.coupon_discount = 0;
        console.log("inside coupon");

        // percentage discount
        if (this.memberDetailsData.coupon_info.discount_type == 1) {
          if (
            this.memberData.price >=
            this.memberDetailsData.coupon_info.minimum_cart_value
          ) {
            let cal_disc =
              (+this.memberDetailsData.coupon_info.discount_value / 100) *
              +this.memberData.price;
            if (cal_disc >= this.memberDetailsData.coupon_info.max_discount) {
              this.memberData.coupon_discount =
                this.memberDetailsData.coupon_info.max_discount;
            } else {
              this.memberData.coupon_discount = cal_disc;
            }
            // // home service
            // if (this.parentData.data.serviceType == "0") {
            //   if (this.discountInfo.home_service_status == 1) {
            //   }
            // }
            // // shop service
            // else if (this.parentData.data.serviceType == "1") {
            //   if (this.discountInfo.shop_service_status == 1) {
            //     let cal_disc =
            //       (+this.discountInfo.discountAmount / 100) *
            //       +this.memberData.price;
            //     console.log(cal_disc);

            //     if (cal_disc >= this.discountInfo.maxDiscount) {
            //       this.newbookingData.discount = this.discountInfo.maxDiscount;
            //     } else {
            //       this.newbookingData.discount = cal_disc;
            //     }
            //   }
            // }
            // // virtual service
            // else if (this.parentData.data.serviceType == "2") {
            //   if (this.discountInfo.virtual_service_status == 1) {
            //     let cal_disc =
            //       (+this.discountInfo.discountAmount / 100) *
            //       +this.memberData.price;
            //     console.log(cal_disc);

            //     if (cal_disc >= this.discountInfo.maxDiscount) {
            //       this.newbookingData.discount = this.discountInfo.maxDiscount;
            //     } else {
            //       this.newbookingData.discount = cal_disc;
            //     }
            //   }
            // }
          }
        }
        // amount discount
        else if (this.memberDetailsData.coupon_info.discount_type == 2) {
          if (
            this.memberData.price >=
            this.memberDetailsData.coupon_info.minimum_cart_value
          ) {
            this.memberData.coupon_discount =
              this.memberDetailsData.coupon_info.discount_value;

            // // home service
            // if (this.parentData.data.serviceType == "0") {
            //   if (this.discountInfo.home_service_status == 1) {
            //   }
            // }
            // // shop service
            // else if (this.parentData.data.serviceType == "1") {
            //   if (this.discountInfo.shop_service_status == 1) {
            //     this.newbookingData.discount = this.discountInfo.discountAmount;
            //   }
            // }
            // // virtual service
            // else if (this.parentData.data.serviceType == "2") {
            //   if (this.discountInfo.virtual_service_status == 1) {
            //     this.newbookingData.discount = this.discountInfo.discountAmount;
            //   }
            // }
          }
        }

        // this.newbookingData.discount = +this.newbookingData.discount.toFixed(2);
      }
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
